/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions

==========================================================================================*/

import axios from '@/axios'
import socket from '@/socket'
import { notifyError, notifyServerError, notifyWarning } from '@/layouts/notifies'
import i18n from '@/i18n/i18n'
import router from '@/router'
import io from '@/io'
import app from '@/main'

export default {
  // JWT
  loginJWT({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('auth/login', {
          username: payload.userDetails.phone,
          password: payload.userDetails.password
        })
        .then(response => {
          if (payload.checkbox_remember_me) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.accessToken)

            // Set ioToken
            localStorage.setItem('ioToken', response.data.ioToken)
          } else {
            // Set accessToken
            sessionStorage.setItem('accessToken', response.data.accessToken)

            // Set ioToken
            sessionStorage.setItem('ioToken', response.data.ioToken)
          }
          // Update user details
          commit(
            'UPDATE_USER_INFO',
            {
              ...response.data.userData,
              checkbox_remember_me: payload.checkbox_remember_me
            },
            { root: true }
          )

          // Set bearer token in axios
          commit('SET_BEARER', response.data.accessToken)

          //Connect if not connected
          socket()

          Promise.all([
            dispatch('wallet/fetchMyWallet', null, { root: true }),
            dispatch('enum/fetchGeneralEnums', null, { root: true }),
            dispatch('config/fetchGeneralConfigs', null, { root: true }),
            dispatch('notices/fetchNotices', null, { root: true })
          ])
            .then(() => resolve(response))
            .catch(() => {
              window.location = '/'
            })
        })
        .catch(error => {
          if (error.response && error.response.status === 401) notifyWarning(i18n.t('messages.login_failed'))
          else notifyServerError(error)
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-unused-vars
  registerUserJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // Check confirm password
      if (payload.password !== payload.confirmPassword) {
        reject({ message: "Password doesn't match. Please try again." })
      }

      axios
        .post('auth/register', {
          username: payload.phone,
          newPassword: payload.password,
          details: payload.details
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          if (error.response.status === 409) notifyError(i18n.t('messages.user_phone_exist'))
          else this.$notifyServerError(error)
          reject(error)
        })
    })
  },
  confirmPhone(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put('auth/confirm', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  forgetPassword(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('auth/forget', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  getProfile() {
    return new Promise((resolve, reject) => {
      axios
        .get('auth/profile')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editProfile(context, userData) {
    return new Promise((resolve, reject) => {
      axios
        .put('auth/profile', userData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  changePassword(context, passwordData) {
    return new Promise((resolve, reject) => {
      axios
        .put('auth/password', passwordData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          if (error.response.status === 401) notifyServerError(i18n.t('users.old_password_error'))
          else notifyServerError(error)
          reject(error)
        })
    })
  },
  resetPassword(context, resetData) {
    return new Promise((resolve, reject) => {
      axios
        .put('auth/password/reset', resetData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  loginAsUser({ commit, rootState, dispatch }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`auth/${userId}/login`)
        .then(response => {
          commit('CLEAR_USER_INFO', {})
          if (rootState.AppActiveUser.checkbox_remember_me) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.accessToken)
          } else {
            // Set accessToken
            sessionStorage.setItem('accessToken', response.data.accessToken)
          }
          // Update user details
          commit(
            'UPDATE_USER_INFO',
            {
              ...response.data.userData,
              checkbox_remember_me: rootState.AppActiveUser.checkbox_remember_me
            },
            { root: true }
          )

          Promise.all([
            dispatch('wallet/fetchMyWallet', null, { root: true }),
            dispatch('enum/fetchGeneralEnums', null, { root: true }),
            dispatch('config/fetchGeneralConfigs', null, { root: true }),
            dispatch('notices/fetchNotices', null, { root: true })
          ])
            .then(() => resolve(response))
            .catch(() => {
              window.location = '/'
            })

          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  logout({ commit }) {
    commit('CLEAR_USER_INFO', {}, { root: true })

    try {
      io.close()
    } catch (error) {
      // console.debug(error)
    }

    const ioToken = localStorage.getItem('ioToken') || sessionStorage.getItem('ioToken')
    axios.delete(`pushes/${ioToken}`)

    try {
      app.$acl.change('guest')
    } catch (error) {
      // console.debug(error)
    }
    router.push({ name: 'page-login' }).catch(() => {})
  }
}
